module.exports = __webpack_public_path__ + "static/plans-bg.659d3626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plans-bg.png
// module id = 673
// module chunks = 79438531329954